export function retirarMascaraTelefone(valor) {
    return valor.replace(/[\(\)\.\s-]+/g, '');
}